import { Link } from 'react-router-dom';
import Breadcrumb from '@/components/base/Breadcrumb';
import RelatedPages from '@/components/base/RelatedPages';

const advantages = [
  {
    icon: 'ri-leaf-line',
    num: '01',
    title: '堅持自然選材',
    desc: '嚴選天然食物來源，拒絕非必要化學添加，每項原料均具備完整來源溯源與身分證明，確保產品的品質與安全性。',
    highlights: ['完整溯源證明', '拒絕化學添加', '食安規範合規', '原料身分證明'],
    imgSrc: 'https://readdy.ai/api/search-image?query=natural%20organic%20botanical%20ingredients%20arranged%20on%20white%20surface%2C%20various%20seeds%20herbs%20roots%20vitamins%20capsules%2C%20clean%20minimal%20food%20photography%2C%20health%20supplement%20raw%20materials%20top%20view&width=700&height=420&seq=adv-img-01&orientation=landscape',
  },
  {
    icon: 'ri-group-line',
    num: '02',
    title: '創造健康三贏',
    desc: '康永不與客戶競爭，專注於品牌端穩健切入、消費者安心補充與製造端品質堅持，達成健康三贏的好循環。',
    highlights: ['品牌端穩健切入', '消費者安心補充', '製造端品質堅持', '三方共好循環'],
    imgSrc: 'https://readdy.ai/api/search-image?query=collaborative%20business%20partners%20shaking%20hands%20in%20bright%20modern%20office%2C%20health%20biotech%20startup%20team%20meeting%2C%20positive%20cooperation%20concept%2C%20green%20plants%20in%20background%2C%20natural%20warm%20light&width=700&height=420&seq=adv-img-02&orientation=landscape',
  },
  {
    icon: 'ri-tools-line',
    num: '03',
    title: '整合式專業服務',
    desc: '整合需求、配方、劑型、視覺、法規與生產，將複雜的產品開發流程拆解為可控步驟，降低溝通成本與市場試錯風險。',
    highlights: ['一站式整合服務', '配方劑型設計', '法規合規審查', '降低試錯風險'],
    imgSrc: 'https://readdy.ai/api/search-image?query=professional%20team%20analyzing%20health%20supplement%20product%20development%20workflow%20on%20large%20screen%2C%20modern%20biotech%20company%20office%2C%20organized%20project%20planning%20board%2C%20clean%20white%20workspace%20with%20natural%20light&width=700&height=420&seq=adv-img-03&orientation=landscape',
  },
  {
    icon: 'ri-scales-line',
    num: '04',
    title: '少量可接單',
    desc: '彈性合作方案：依照客戶需求提供彈性的量產方案 ，協助新品牌、小眾市場 降低上市難度 讓好的營養也能無壓力的提供給消費者',
    highlights: ['彈性起訂量', '新品牌友善', '降低庫存壓力', '快速市場測試'],
    imgSrc: 'https://readdy.ai/api/search-image?query=small%20batch%20health%20supplement%20production%20line%20in%20clean%20white%20GMP%20factory%2C%20neatly%20arranged%20capsule%20bottles%20and%20packaging%2C%20precise%20manufacturing%20process%2C%20minimal%20clinical%20aesthetic&width=700&height=420&seq=adv-img-04&orientation=landscape',
  },
];

const stats = [
  { value: '350+', label: '合作品牌數' },
  { value: '1000+', label: '開發產品數' },
  { value: '20+', label: '專業年資' },
  { value: '95%', label: '客戶好評率' },
];

export default function AdvantagesContent() {
  return (
    <>
      {/* Hero */}
      <section className="relative pt-20 min-h-[380px] md:min-h-[440px] flex items-end overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=modern%20biotech%20health%20supplement%20company%20building%20exterior%20with%20green%20living%20wall%20plants%2C%20professional%20corporate%20headquarters%20surrounded%20by%20nature%2C%20clean%20architecture%20daylight&width=1920&height=440&seq=adv-hero-bg-01&orientation=landscape"
            alt="康永優勢背景"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0d2310]/90 via-[#0d2310]/60 to-[#0d2310]/20" />
        </div>
        <div className="relative z-10 w-full max-w-screen-xl mx-auto px-6 lg:px-10 pb-14 pt-28">
          <div className="max-w-2xl">
            <Breadcrumb
              items={[
                { label: '首頁', href: '/' },
                { label: '康永優勢' },
              ]}
              className="mb-4 text-gray-300"
            />
            <span className="inline-block bg-[#4CAF50]/25 border border-[#4CAF50]/50 text-green-300 text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-5">
              首頁 · 康永優勢
            </span>
            <h1 className="text-white font-bold text-[2.25rem] md:text-[2.875rem] leading-tight mb-4">
              康永優勢
            </h1>
            <p className="text-gray-200 text-[1.0625rem] leading-[1.75] max-w-xl">
              從天然選材、品牌合作、生產整合到少量起訂，協助品牌降低開發門檻與市場風險。
            </p>
          </div>
        </div>
      </section>

      {/* Stats bar */}
      <section className="bg-white border-b border-gray-100 py-8">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {stats.map((s) => (
              <div key={s.label} className="text-center">
                <div className="text-[#4CAF50] font-bold text-[2rem] md:text-[2.25rem] leading-none mb-1">{s.value}</div>
                <div className="text-gray-500 text-[0.875rem]">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Advantages - alternating image-text */}
      <section className="py-6 bg-[#f7faf7]">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10 space-y-6 py-10">
          {advantages.map((adv, idx) => (
            <div
              key={adv.num}
              className={`bg-white rounded-2xl border border-gray-100 overflow-hidden flex flex-col ${idx % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'}`}
            >
              {/* Image */}
              <div className="lg:w-[44%] flex-shrink-0" style={{ minHeight: '300px' }}>
                <img
                  src={adv.imgSrc}
                  alt={adv.title}
                  className="w-full h-full object-cover object-top"
                  style={{ minHeight: '260px' }}
                />
              </div>
              {/* Content */}
              <div className="flex-1 p-8 lg:p-10 flex flex-col justify-center">
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-green-50 border border-green-100">
                    <i className={`${adv.icon} text-[#4CAF50] text-xl`} />
                  </div>
                  <span className="text-[#4CAF50] font-bold text-[1.5rem] opacity-30">{adv.num}</span>
                </div>
                <h3 className="text-[#1a2e1a] font-bold text-[1.5rem] md:text-[1.75rem] mb-4">{adv.title}</h3>
                <p className="text-gray-500 text-[1.0625rem] leading-[1.85] mb-6">{adv.desc}</p>
                <div className="flex flex-wrap gap-2">
                  {adv.highlights.map((h) => (
                    <span
                      key={h}
                      className="inline-flex items-center gap-1.5 text-[0.8125rem] text-[#4CAF50] bg-green-50 border border-green-100 px-3 py-1 rounded-full"
                    >
                      <i className="ri-check-line text-xs" />
                      {h}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Why us */}
      <section className="py-20 bg-white">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10 text-center">
          <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-5 border border-green-200">
            為什麼選擇康永
          </span>
          <h2 className="text-[#1a2e1a] font-bold text-[1.75rem] md:text-[2.125rem] mb-4">
            不只是代工廠，更是品牌的生技夥伴
          </h2>
          <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-2xl mx-auto mb-12">
            康永生技與一般代工廠的最大差別在於：我們把每一個合作視為長期夥伴關係，而不只是完成訂單。
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {[
              { icon: 'ri-user-voice-line', title: '專屬顧問服務', desc: '從首次諮詢到交貨後追蹤，全程由專人負責您的案子' },
              { icon: 'ri-file-shield-line', title: 'NDA 保密保障', desc: '嚴格簽訂保密協議，您的配方創意完全受到保護' },
              { icon: 'ri-building-2-line', title: 'GMP 廠房生產', desc: '台中 GMP 合規廠房，每批次均通過嚴格品管審核' },
              { icon: 'ri-scales-2-line', title: '法規合規審查', desc: '熟悉食品保健廣告法規，協助確保上市合規性' },
              { icon: 'ri-refresh-line', title: '快速反應能力', desc: '小量測試、快速樣品、彈性調整，搶占市場先機' },
              { icon: 'ri-bar-chart-line', title: '市場趨勢洞察', desc: '掌握保健市場最新趨勢，協助品牌選對方向' },
            ].map((item) => (
              <div key={item.title} className="bg-[#f7faf7] rounded-2xl p-6 border border-gray-100 text-left hover:border-green-200 transition-all duration-300">
                <div className="w-11 h-11 flex items-center justify-center bg-white rounded-xl border border-green-100 mb-4">
                  <i className={`${item.icon} text-[#4CAF50] text-xl`} />
                </div>
                <h4 className="text-[#1a2e1a] font-bold text-[1.0625rem] mb-2">{item.title}</h4>
                <p className="text-gray-500 text-[0.9375rem] leading-[1.75]">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-[#f7faf7]">
        <div className="max-w-screen-xl mx-auto px-6 lg:px-10 text-center">
          <h2 className="text-[#1a2e1a] font-bold text-[1.75rem] md:text-[2.125rem] leading-tight mb-4">
            帶著您的想法來，其餘交給我們
          </h2>
          <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-xl mx-auto mb-8">
            康永生技提供免費初步評估，讓您了解如何以最低成本啟動第一個保健品牌。
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link
              to="/cooperation/process"
              className="whitespace-nowrap inline-flex items-center gap-2 bg-[#4CAF50] hover:bg-[#43a047] text-white font-bold text-[1.0625rem] px-10 py-4 rounded-full transition-all duration-300 cursor-pointer"
            >
              了解合作流程
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/home/experience"
              className="whitespace-nowrap inline-flex items-center gap-2 border border-[#4CAF50] text-[#4CAF50] hover:bg-[#4CAF50] hover:text-white font-semibold text-[1.0625rem] px-10 py-4 rounded-full transition-all duration-300 cursor-pointer"
            >
              查看服務經歷
            </Link>
          </div>
        </div>
      </section>
      <RelatedPages items={[
        { title: '核心理念', desc: '康永生技的品牌信念，回到自然本質，就是正確的保健之道。', href: '/home/core' },
        { title: '專業生產', desc: '了解康永 GMP 廠房與品管流程，為品牌提供最安全的生產保障。', href: '/about/production' },
        { title: '洽詢代工服務', desc: '填寫諮詢表單，讓康永幫您評估最適合的合作方式。', href: '/contact/form' },
      ]} />
    </>
  );
}
